import React, { useState, useEffect } from "react";
import "./about2.css";
import linkedin from "../../../assets/images/social-media/linkedin-logo (1).png";
import Client from "../../common/axiosApi";

const About2Content = () => {
  const [management, setManagement] = useState([]);

  const getManagement = async () => {
    try {
      const getManagementResponse = await Client.get(
        "/management/getManagement"
      );
      // console.log(getManagementResponse.data.getManagement);

      if (getManagementResponse.status === 200) {
        setManagement(getManagementResponse.data.getManagement);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getManagement();
  }, []);

  return (
    <>
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-12">
            <p className="about2-heading">This is SAASphire</p>
            <p className="about2-content-heading">
              We speak Customer Experience—Inside and Out.
            </p>

            <p className="about2-content">
              We turn real business requirements into Salesforce outcomes that
              your teams (and your customers) can feel. From strategy to shipped
              solutions, we make CX transformation practical, measurable, and
              sustainable.
            </p>

            <p className="about2-content-heading">Our story</p>

            <p className="about2-content">
              Our team has spent years across the CX ecosystem—global
              consultancies and boutiques, in-house on the client side, inside
              Salesforce itself, and with other leading customer-experience
              platforms. That mix means we “get” your world fast: your industry,
              your processes, and yes—your dialect.
            </p>
          </div>

          <div className="col-md-12 mb-3">
            <div className="keypeople-content">
              <h4>Get to know us</h4>
              <p>
                Our founding team brings decades of relevant Salesforce
                experience between them. Be it from the perspective of the
                consultancy, the end customer or directly from Salesforce.
              </p>
            </div>

            <div className="row">
              {management &&
                management.map((eachPeople) => {
                  return (
                    <div className="col-md-6 offset-md-3 mt-2">
                      <div class="card_data">
                        <img src={eachPeople.image.url} alt="" />
                        <div class="pro_content">
                          <h2>{eachPeople.name}</h2>
                          <p class="position">{eachPeople.position}</p>
                          <div class="social_icons">
                            <a href={eachPeople.link}>
                              <img src={linkedin} alt="social" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About2Content;
